import hexadecimalToRgb from "./hexadecimalToRgb";

export default function textColorBasedOnBackground(value: string) {
	const colorRgb = hexadecimalToRgb(value);
	if(!colorRgb)
		return "#000000";
	if ((colorRgb.r*0.299 + colorRgb.g*0.587 + colorRgb.b*0.114) > 186) {
		return "#000000";
	}
	return "#ffffff";
}

